const doc = [({"da":({"js":({"activities":({"index":({"card":({"description":({"read_less":"Læs mindre", "read_more":"Læs mere"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;